import { useAppStore } from '@/store/useAppStore.ts'

export function AssumptionsSummary() {
  const result = useAppStore((s) => s.runtimeResult)
  const show = useAppStore((s) => s.showAssumptionsSummary)
  const toggle = useAppStore((s) => s.toggleAssumptionsSummary)

  if (!result?.assumptionsList.length) return null

  return (
    <div className="assumptions-summary">
      <button
        type="button"
        className="assumptions-summary__toggle"
        onClick={toggle}
        aria-expanded={show}
      >
        Assumptions ({result.assumptionsList.length})
      </button>
      {show && (
        <ul className="assumptions-summary__list">
          {result.assumptionsList.map((a, i) => (
            <li key={i} className="assumptions-summary__item">
              <span className="assumptions-summary__dot" aria-hidden="true" />
              {a}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
